import React, { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";
import { Button } from "@/components/ui/button";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import PictureSection from "./PictureSection";


const PersonalInfo = () => {
	const [loading, setLoading] = useState(true);
	const [editSection, setEditSection] = useState(null);

	const [personal, setPersonal] = useState({});
	const [exEmployee, setExEmployee] = useState({});
	const [permanentAddress, setPermanentAddress] = useState({});
	const [presentAddress, setPresentAddress] = useState({});
	const [categories, setCategories] = useState([]);
	const [error, setError] = useState(null);
	
	const [user, setUser] = useState({
		name: secureLocalStorage.getItem("name"),
		picture: secureLocalStorage.getItem("picture"), // or null
	});
	
	const categoryPost = async () => {
		setLoading(true);
		setError(null);

		try {
			const payload = {
				userId: import.meta.env.VITE_API_USER,
				password: import.meta.env.VITE_API_PASS,				
		    };
			const api = axios.create({
				baseURL: import.meta.env.VITE_API_BASE_URL,
				headers: { "Content-Type": "application/json" },
			});
			const response = await api.post("/job-category", payload);
			
			// Loop data (array)
			setCategories(response.data || []);			
		} catch (err) {
			console.log(err);
		    setError(err.message || "Something went wrong");		   
		} finally {
		  setLoading(false);
		}
	};
	useEffect(() => {		
		categoryPost();		
	}, []);
	
  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
		const payload = {
			userId: import.meta.env.VITE_API_USER,
			password: import.meta.env.VITE_API_PASS,
			user: secureLocalStorage.getItem("user"),
			token:secureLocalStorage.getItem("token"),
		};
		const api = axios.create({
			baseURL: import.meta.env.VITE_API_BASE_URL,
			headers: { "Content-Type": "application/json" },
		});
		const res = await api.post("/personal-info", payload);
       
        const data = res.data || {};

        setPersonal(data.personal || {});
        setExEmployee(data.exEmployee || {});
        setPermanentAddress(data.permanentAddress || {});
        setPresentAddress(data.presentAddress || {});
      } catch (error) {
        console.error("Failed to load personal info:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleChange = (e, setter) => {
    const { name, value } = e.target;
    setter((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = async (sectionData, endpoint) => {
    try {
		const payload = new FormData();

		// Append user credentials (from .env and local storage)
		payload.append("userId", import.meta.env.VITE_API_USER);
		payload.append("password", import.meta.env.VITE_API_PASS);
		payload.append("user", secureLocalStorage.getItem("user"));
		payload.append("token", secureLocalStorage.getItem("token"));
		// Append section data (supports text fields, objects, files)
		Object.entries(sectionData).forEach(([key, value]) => {
		  if (value !== undefined && value !== null) {
			payload.append(key, value);
		  }
		});
		const api = axios.create({
			baseURL: import.meta.env.VITE_API_BASE_URL,
			headers: { "Content-Type": "application/json" },
		});
		const res = await api.post(endpoint, payload);
      
		alert("✅ Information updated successfully!");
		setEditSection(null);
    } catch (error) {
		console.error("Error saving data:", error);
		alert("❌ Failed to update. Please try again.");
    }
  };

  if (loading)
    return (
      <div className="bg-white rounded-xl shadow-md p-6 text-center text-blue-600 font-medium">
        Loading Personal Information...
      </div>
    );
	const religion =["Islam","Hinduism","Buddhism","Christianity","Other"];
	const nationalityT=["By Birth","Migrated"];
	const gender=["Male","Female"];
	const mstatus=["Single","Married","Divorced","Separated","Widowed"];
	const blgroup=["A+","A-","B+","B-","O+","O-","AB+","AB-"];
  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3 }}
      className="bg-white rounded-xl p-6 shadow-md space-y-10"
    >
		<PictureSection
			currentPictureUrl={user.picture}
			onUpdate={(newUrl) => setUser({ ...user, picture: newUrl })}
		/>
		{/* ==============================
          PERSONAL INFORMATION SECTION
		============================== */}
      <div className="relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-[#1A2B63]">
            Personal Information
          </h2>
          <Button
            variant="outline"
            onClick={() =>
              setEditSection(editSection === "personal" ? null : "personal")
            }
          >
            {editSection === "personal" ? "Cancel" : "Edit"}
          </Button>
        </div>

        {editSection === "personal" ? (
          <form className="grid grid-cols-2 md:grid-cols-3 gap-5">
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Job Category
                </label>
                <Select 
					name="category"
					className="text-sm"
					options={categories.map((cat) => ({
					  value: cat.id || cat.occupation,
					  label: cat.occupation,
					}))}
					placeholder="Search or select category..."
					value={
					  personal.category
						? (() => {
							const selected = categories.find(
							  (c) => c.id === personal.category || c.occupation === personal.category
							);
							return selected
							  ? { value: selected.id || selected.occupation, label: selected.occupation }
							  : { value: personal.category, label: personal.category };
						  })()
						: null
					}
					onChange={(selected) =>
					  setPersonal((prev) => ({
						...prev,
						category: selected ? selected.value : "",
					  }))
					}
					isClearable
					isSearchable
				/>
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Name
                </label>
                <input
                  type="text"
                  name="name"
                  value={personal.name || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Date of Birth
                </label>
                <input
                  type="date"
                  name="dob"
                  value={personal.dob || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Father’s Name
                </label>
                <input
                  type="text"
                  name="fatherName"
                  value={personal.fatherName || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Mother’s Name
                </label>
                <input
                  type="text"
                  name="motherName"
                  value={personal.motherName || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
			  <label className="text-gray-600 text-sm font-semibold mb-1">
				Religion
			  </label>
			  <Select
				name="religion"
				className="text-sm"
				options={religion.map((cat) => ({
				  value: cat,
				  label: cat,
				}))}
				placeholder="Search or select Religion..."
				value={
				  personal.religion
					? {
						value: personal.religion,
						label: nationalityT.find((c) => c === personal.religion) || personal.religion,
					  }
					: null
				}
				onChange={(selected) =>
				  setPersonal((prev) => ({
					...prev,
					religion: selected ? selected.value : "",
				  }))
				}
				
				isClearable
				isSearchable
			  />
			</div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Birth Place
                </label>
                <input
                  type="text"
                  name="countryOfBirth"
                  value={personal.countryOfBirth || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			
			<div className="flex flex-col">
			  <label className="text-gray-600 text-sm font-semibold mb-1">
				Nationality Type
			  </label>
			  <Select
				name="nationalityType"
				className="text-sm"
				options={nationalityT.map((cat) => ({
				  value: cat,
				  label: cat,
				}))}
				placeholder="Search or select Nationality Type..."
				value={
				  personal.nationalityType
					? {
						value: personal.nationalityType,
						label: nationalityT.find((c) => c === personal.nationalityType) || personal.nationalityType,
					  }
					: null
				}
				onChange={(selected) =>
				  setPersonal((prev) => ({
					...prev,
					nationalityType: selected ? selected.value : "",
				  }))
				}
				isClearable
				isSearchable
			  />
			</div>
			<div className="flex flex-col">
			  <label className="text-gray-600 text-sm font-semibold mb-1">
				Gender
			  </label>
			  <Select
				name="gender"
				className="text-sm"
				options={gender.map((cat) => ({
				  value: cat,
				  label: cat,
				}))}
				placeholder="Search or select Gender..."
				value={
				  personal.gender
					? {
						value: personal.gender,
						label: gender.find((c) => c === personal.gender) || personal.gender,
					  }
					: null
				}
				onChange={(selected) =>
				  setPersonal((prev) => ({
					...prev,
					gender: selected ? selected.value : "",
				  }))
				}
				isClearable
				isSearchable
			  />
			</div>
			<div className="flex flex-col">
			  <label className="text-gray-600 text-sm font-semibold mb-1">
				Marital Status
			  </label>
			  <Select
				name="maritalStatus"
				className="text-sm"
				options={mstatus.map((cat) => ({
				  value: cat,
				  label: cat,
				}))}
				placeholder="Search or select Marital Status..."
				value={
				  personal.maritalStatus
					? {
						value: personal.maritalStatus,
						label: mstatus.find((c) => c === personal.maritalStatus) || personal.maritalStatus,
					  }
					: null
				}
				onChange={(selected) =>
				  setPersonal((prev) => ({
					...prev,
					maritalStatus: selected ? selected.value : "",
				  }))
				}
				isClearable
				isSearchable
			  />
			</div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Spouse Name
                </label>
                <input
                  type="text"
                  name="spouseName"
                  value={personal.spouseName || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
			  <label className="text-gray-600 text-sm font-semibold mb-1">
				Blood Group
			  </label>
			  <Select
				name="bloodGroup"
				className="text-sm"
				options={blgroup.map((cat) => ({
				  value: cat,
				  label: cat,
				}))}
				placeholder="Search or select Marital Status..."
				value={
				  personal.bloodGroup
					? {
						value: personal.bloodGroup,
						label: blgroup.find((c) => c === personal.bloodGroup) || personal.bloodGroup,
					  }
					: null
				}
				onChange={(selected) =>
				  setPersonal((prev) => ({
					...prev,
					bloodGroup: selected ? selected.value : "",
				  }))
				}
				isClearable
				isSearchable
			  />
			</div>
			
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Nationality
                </label>
                <input
                  type="text"
                  name="nationality"
                  value={personal.nationality || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Contact No.
                </label>
                <input
                  type="text"
                  name="contactNo"
                  value={personal.contactNo || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Email
                </label>
                <input
                  type="text"
                  name="email"
                  value={personal.email || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Alt. Contact No.
                </label>
                <input
                  type="text"
                  name="altContactNo"
                  value={personal.altContactNo || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  Alt. Email
                </label>
                <input
                  type="text"
                  name="altEmail"
                  value={personal.altEmail || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			<div className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  NID Number
                </label>
                <input
                  type="text"
                  name="nidNumber"
                  value={personal.nidNumber || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
            </div>
			
            {[             
             
              { label: "Passport", name: "passport" },
              { label: "Passport Issue Date", name: "passportIssueDate", type: "date" },
              { label: "Passport Expiry Date", name: "passportExpiryDate", type: "date" },              
              { label: "Disability", name: "disability" },
            ].map((field, i) => (
			  
              <div key={i} className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  {field.label}
                </label>
                <input
                  type={field.type || "text"}
                  name={field.name}
                  value={personal[field.name] || ""}
                  onChange={(e) => handleChange(e, setPersonal)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
              </div>
            ))}

            <div className="col-span-full text-right mt-2">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleSave(personal, "/update-personal-info");
                }}
                className="bg-blue-600 text-white"
              >
                Save Changes
              </Button>
            </div>
          </form>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-gray-600 text-sm">
            <p><strong>Name:</strong> {personal.name}</p>
            <p><strong>Date of Birth:</strong> {personal.dob}</p>
			<p><strong>Father Name:</strong> {personal.fatherName}</p>
			<p><strong>Mother Name:</strong> {personal.motherName}</p>
			<p><strong>Religion:</strong> {personal.religion}</p>
			<p><strong>Birth Place:</strong> {personal.countryOfBirth}</p>
			<p><strong>Nationality Type:</strong> {personal.nationalityType}</p>
			<p><strong>Gender:</strong> {personal.gender}</p>
			<p><strong>Marital Status:</strong> {personal.maritalStatus}</p>
			<p><strong>Spouse Name:</strong> {personal.spouseName}</p>
			<p><strong>Blood Group:</strong> {personal.bloodGroup}</p>
			<p><strong>Nationality:</strong> {personal.nationality}</p>			
            <p><strong>Contact:</strong> {personal.contactNo}</p>
            <p><strong>Email:</strong> {personal.email}</p>
            <p><strong>Alt. Contact No.:</strong> {personal.altContactNo}</p>
            <p><strong>Alt. Email:</strong> {personal.altEmail}</p>
			<p><strong>NID Number:</strong> {personal.nidNumber}</p>
			<p><strong>Passport:</strong> {personal.passport}</p>
			<p><strong>Passport Issue Date:</strong> {personal.passportIssueDate}</p>
			<p><strong>Passport Expiry Date:</strong> {personal.passportExpiryDate}</p>
			<p><strong>Disability:</strong> {personal.disability}</p>
          </div>
        )}
      </div>

      {/* ==============================
          EX-IIUC EMPLOYEE SECTION
      ============================== */}
      <div className="relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-[#1A2B63]">
            Are you an Ex-IIUC Employee?
          </h2>
          <Button
            variant="outline"
            onClick={() =>
              setEditSection(editSection === "ex" ? null : "ex")
            }
          >
            {editSection === "ex" ? "Cancel" : "Edit"}
          </Button>
        </div>

        {editSection === "ex" ? (
          <form className="grid grid-cols-2 md:grid-cols-3 gap-5">
            {[
              { label: "Employee ID", name: "employeeId" },
              { label: "Joining Date", name: "joiningDate", type: "date" },
              { label: "Last Working Day", name: "lastWorkingDay", type: "date" },
              { label: "Supervisor Name", name: "supervisorName" },
              { label: "Supervisor Phone", name: "supervisorPhone" },
              { label: "Supervisor Designation", name: "supervisorDesignation" },
              { label: "Supervisor Email", name: "supervisorEmail" },
            ].map((field, i) => (
              <div key={i} className="flex flex-col">
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  {field.label}
                </label>
                <input
                  type={field.type || "text"}
                  name={field.name}
                  value={exEmployee[field.name] || ""}
                  onChange={(e) => handleChange(e, setExEmployee)}
                  className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                />
              </div>
            ))}

            <div className="col-span-full text-right mt-2">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleSave(exEmployee, "/update-ex-employee");
                }}
                className="bg-blue-600 text-white"
              >
                Save Changes
              </Button>
            </div>
          </form>
        ) : (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 text-gray-600 text-sm">
            <p><strong>Employee ID:</strong> {exEmployee.employeeId}</p>
            <p><strong>Joining Date:</strong> {exEmployee.joiningDate}</p>
			<p><strong>Last Working Day:</strong> {exEmployee.lastWorkingDay}</p>
			<p><strong>Supervisor:</strong> {exEmployee.supervisorName}</p>
			<p><strong>Supervisor Phone:</strong> {exEmployee.supervisorPhone}</p>
			<p><strong>Supervisor Designation:</strong> {exEmployee.supervisorDesignation}</p>
			<p><strong>Supervisor Email:</strong> {exEmployee.supervisorEmail}</p>
          </div>
        )}
      </div>

      {/* ==============================
          PERMANENT ADDRESS SECTION
      ============================== */}
      <div className="relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-[#1A2B63]">
            Permanent Address (As per NID/Passport)
          </h2>
          <Button
            variant="outline"
            onClick={() =>
              setEditSection(editSection === "permanent" ? null : "permanent")
            }
          >
            {editSection === "permanent" ? "Cancel" : "Edit"}
          </Button>
        </div>

        {editSection === "permanent" ? (
          <form className="grid grid-cols-2 gap-5">
            {[
              { label: "Full Address", name: "fullAddress", type: "textarea" },
              { label: "District", name: "district" },
              { label: "Division", name: "division" },
              { label: "Postal Code", name: "postalCode" },
              { label: "Thana / Upazilla", name: "thana" },
            ].map((field, i) => (
              <div
                key={i}
                className={`flex flex-col ${field.name === "fullAddress" ? "col-span-2" : ""}`}
              >
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  {field.label}
                </label>
                {field.type === "textarea" ? (
                  <textarea
                    name={field.name}
                    value={permanentAddress[field.name] || ""}
                    onChange={(e) => handleChange(e, setPermanentAddress)}
                    className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200 min-h-[90px]"
                  />
                ) : (
                  <input
                    name={field.name}
                    value={permanentAddress[field.name] || ""}
                    onChange={(e) => handleChange(e, setPermanentAddress)}
                    className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                  />
                )}
              </div>
            ))}
            <div className="col-span-2 text-right mt-2">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleSave(permanentAddress, "/update-permanent-address");
                }}
                className="bg-blue-600 text-white"
              >
                Save Changes
              </Button>
            </div>
          </form>
        ) : (
          <div className="text-gray-600 text-sm space-y-1">
            <p><strong>Full Address:</strong> {permanentAddress.fullAddress}</p>
			<p><strong>Division:</strong> {permanentAddress.division}</p>
            <p><strong>District:</strong> {permanentAddress.district}</p>
			<p><strong>Postal Code:</strong> {permanentAddress.postalCode}</p>
			<p><strong>Thana/Upazilla:</strong> {permanentAddress.thana}</p>
          </div>
        )}
      </div>

      {/* ==============================
          PRESENT ADDRESS SECTION
      ============================== */}
      <div className="relative">
        <div className="flex justify-between items-center mb-6">
          <h2 className="text-2xl font-semibold text-[#1A2B63]">Present Address</h2>
          <Button
            variant="outline"
            onClick={() =>
              setEditSection(editSection === "present" ? null : "present")
            }
          >
            {editSection === "present" ? "Cancel" : "Edit"}
          </Button>
        </div>

        {editSection === "present" ? (
          <form className="grid grid-cols-2 gap-5">
            {[
              { label: "Full Address", name: "fullAddress", type: "textarea" },
              { label: "District", name: "district" },
              { label: "Division", name: "division" },
              { label: "Postal Code", name: "postalCode" },
              { label: "Thana / Upazilla", name: "thana" },
            ].map((field, i) => (
              <div
                key={i}
                className={`flex flex-col ${field.name === "fullAddress" ? "col-span-2" : ""}`}
              >
                <label className="text-gray-600 text-sm font-semibold mb-1">
                  {field.label}
                </label>
                {field.type === "textarea" ? (
                  <textarea
                    name={field.name}
                    value={presentAddress[field.name] || ""}
                    onChange={(e) => handleChange(e, setPresentAddress)}
                    className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200 min-h-[90px]"
                  />
                ) : (
                  <input
                    name={field.name}
                    value={presentAddress[field.name] || ""}
                    onChange={(e) => handleChange(e, setPresentAddress)}
                    className="border border-blue-300 rounded-lg p-2 focus:ring-2 focus:ring-blue-500 outline-none transition-all duration-200"
                  />
                )}
              </div>
            ))}
            <div className="col-span-2 text-right mt-2">
              <Button
                onClick={(e) => {
                  e.preventDefault();
                  handleSave(presentAddress, "/update-present-address");
                }}
                className="bg-blue-600 text-white"
              >
                Save Changes
              </Button>
            </div>
          </form>
        ) : (
          <div className="text-gray-600 text-sm space-y-1">
            <p><strong>Full Address:</strong> {presentAddress.fullAddress}</p>
			<p><strong>Division:</strong> {presentAddress.division}</p>
            <p><strong>District:</strong> {presentAddress.district}</p>
			<p><strong>Postal Code:</strong> {presentAddress.postalCode}</p>
			<p><strong>Thana/Upazilla:</strong> {presentAddress.thana}</p>
          </div>
        )}
      </div>
    </motion.div>
  );
};

export default PersonalInfo;
